import { Component, OnInit } from '@angular/core';
import { environment } from '@environments/environment';
import { CategoriesService } from '@service/categories.service';
import { StateService } from '@service/state.service';

@Component({
  selector: 'create-panel',
  templateUrl: './create-panel.component.html',
  styleUrls: ['./create-panel.component.scss'],
})
export class CreatePanelComponent implements OnInit {
  public environment = environment;

  public isPanelExpanded: boolean = false;

  constructor(
    public StateService: StateService,
    public CategoriesService: CategoriesService,
  ) {}

  ngOnInit(): void {}
}
